/** @jsxImportSource theme-ui */
import { useRole } from "hooks/UseRole";
import Image from "next/image";
import Link from "next/link";
import { Button } from "theme-ui";

import DashboardLinks from "./DashboardLinks";
import NavLink from "./NavLink";

interface MobileNavProps {
  theme: "BLUE" | "CREAM";
  isOpen: boolean;
  links: {
    href: string;
    text: string;
  }[];
}
const MobileNav = ({ theme, isOpen, links }: MobileNavProps) => {
  const currentRole = useRole();

  console.log("mobile nav current role", currentRole);

  return (
    <nav
      sx={{
        width: "100vw",
        height: isOpen ? "100vh" : 0,
        overflow: "hidden",
        position: "absolute",
        inset: "0%",
        display: "flex",
        justifyContent: "center",
        bg: theme === "CREAM" ? "themedDarkBlue" : "white",
        transition: "height 0.2s ease-out",
      }}
    >
      <ul
        sx={{
          mt: "120px",
          p: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          listStyleType: "none",
          li: {
            mb: 5,
          },
        }}
      >
        <DashboardLinks />
        {links.map(({ href, text }) => (
          <li key={`mobile:${href}`}>
            <NavLink href={href} text={text} />
          </li>
        ))}

        {currentRole &&
        (currentRole[0].length > 0 || currentRole[1].length > 0) ? (
          <li>
            <Link href="/api/auth/logout">
              <Button
                as="a"
                variant="dashboardSidebar"
                sx={{
                  color: "themedDarkBlue",
                  textDecoration: "none",
                }}
              >
                <span
                  sx={{
                    ml: "5px",
                    pr: "5px",
                    img: {
                      fill: "red",
                    },
                  }}
                >
                  <Image
                    src="/img/icons/logout-icon.svg"
                    alt=""
                    width={17}
                    height={17}
                    layout="fixed"
                  />
                </span>
                Logout
              </Button>
            </Link>
          </li>
        ) : (
          <li>
            {" "}
            <Link href="/api/auth/login">
              <Button
                as="a"
                variant="dashboardSidebar"
                sx={{
                  variant: "links.header",
                  color: "inherit",
                  textDecoration: "none",
                }}
              >
                Login
              </Button>
            </Link>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default MobileNav;
